import { FolderContent } from '@/api/generatedApi';
import { CreateFolderModal } from '@/components/modals/CreateFolderModal';
import { DeleteAssetModal } from '@/components/modals/DeleteAssetModal';
import { DeleteFolderModal } from '@/components/modals/DeleteFolderModal';
import { LabelAssetModal } from '@/components/modals/LabelAssetModal';
import { RenameFolderModal } from '@/components/modals/RenameFolderModal';
import { MoveFolderModal } from '@/components/modals/MoveFolderModal/MoveFolderModal';
import { MoveAssetModal } from '@/components/modals/MoveAssetModal/MoveAssetModal';
import { ReplaceAssetFileModal } from '@/components/modals/ReplaceAssetFileModal';
import { useSingleItemModals } from './useSingleItemModals';

export const SingleItemModals = <T extends FolderContent>({
  createFolderModal,
  deleteAssetModal,
  deleteFolderModal,
  renameFolderModal,
  moveFolderModal,
  moveAssetModal,
  replaceAssetFileModal,
  labelAssetModal,
  confirmDeleteAsset,
  confirmDeleteFolder,
}: ReturnType<typeof useSingleItemModals<T>>) => (
  <>
    <CreateFolderModal
      isOpen={createFolderModal.isOpen}
      onClose={createFolderModal.close}
      parentFolder={createFolderModal.item}
    />
    {deleteAssetModal.item?.contentType === 'asset' && (
      <DeleteAssetModal
        isOpen={deleteAssetModal.isOpen}
        onClose={deleteAssetModal.close}
        onDelete={confirmDeleteAsset}
        asset={deleteAssetModal.item}
      />
    )}
    {deleteFolderModal.item?.contentType === 'folder' && (
      <DeleteFolderModal
        isOpen={deleteFolderModal.isOpen}
        onClose={deleteFolderModal.close}
        folder={deleteFolderModal.item}
        onDelete={confirmDeleteFolder}
      />
    )}
    <RenameFolderModal
      isOpen={renameFolderModal.isOpen}
      onClose={renameFolderModal.close}
      folder={renameFolderModal.item}
    />
    <MoveFolderModal isOpen={moveFolderModal.isOpen} onClose={moveFolderModal.close} folder={moveFolderModal.item} />
    <MoveAssetModal isOpen={moveAssetModal.isOpen} onClose={moveAssetModal.close} asset={moveAssetModal.item} />
    <ReplaceAssetFileModal
      isOpen={replaceAssetFileModal.isOpen}
      onClose={replaceAssetFileModal.close}
      asset={replaceAssetFileModal.item}
    />
    {labelAssetModal.item && (
      <LabelAssetModal asset={labelAssetModal.item} open={labelAssetModal.isOpen} onClose={labelAssetModal.close} />
    )}
  </>
);
